import React from 'react';
import Header from './Header';
import Sidebar, { MobileNav } from './Sidebar';
import Footer from './Footer';
import { useWallet } from '../../context/WalletContext';
import { useNetworkGuard } from '../../hooks/useNetworkGuard';

const Layout = ({ children, dashboard = false }) => {
  useNetworkGuard();
  const { account, networkOk, switching, switchNetwork } = useWallet();

  return (
    <div className="app-shell">
      <Header />
      {account && !networkOk && (
        <div style={{
          background: 'var(--bnb-yellow-soft)',
          borderBottom: '1px solid var(--border-yellow)',
          color: 'var(--bnb-yellow)',
          padding: '10px 16px',
          textAlign: 'center',
          fontSize: 13,
          fontWeight: 600
        }}>
          Wrong network detected — {switching ? 'switching…' : 'auto-switching to the correct network…'}
          {!switching && (
            <button className="btn btn-sm btn-outline" style={{ marginLeft: 12 }} onClick={switchNetwork}>
              Switch now
            </button>
          )}
        </div>
      )}
      <div className="main-layout">
        {dashboard && <Sidebar />}
        <main className="main-content anim-fade">{children}</main>
      </div>
      {dashboard && <MobileNav />}
      <Footer />
    </div>
  );
};

export default Layout;
